import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import { Trash2, AlertTriangle, X } from "lucide-react";

const EditInternships = () => {
  const { role } = useAuth();
  const navigate = useNavigate();
  const [internships, setInternships] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [toast, setToast] = useState("");

  useEffect(() => {
    if (role !== "admin") {
      navigate("/");
      return;
    }

    const fetchInternships = async () => {
      try {
        const snap = await getDocs(collection(db, "internships"));
        setInternships(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (error) {
        console.error("Error fetching internships:", error);
      }
    };
    fetchInternships();
  }, [role, navigate]);

  const handleDelete = async (id) => {
    try {
      const item = internships.find((i) => i.id === id);
      await deleteDoc(doc(db, "internships", id));
      setInternships(internships.filter((i) => i.id !== id));
      setDeleteId(null);
      setToast(`"${item.title}" deleted`);
      setTimeout(() => setToast(""), 3000);
    } catch (error) {
      console.error("Error deleting internship:", error);
    }
  };

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        All Internships ({internships.length})
      </h2>

      {internships.length === 0 ? (
        <p className="text-center text-gray-500 py-8">No internships to edit.</p>
      ) : (
        <div className="space-y-3">
          {internships.map((item) => (
            <div key={item.id} className={`flex items-center justify-between p-4 rounded-lg border transition-colors ${deleteId === item.id ? "border-red-200 bg-red-50" : "border-gray-100 hover:border-gray-200"}`}>
              <div className="min-w-0 flex-1">
                <p className="font-medium text-gray-900 truncate">{item.title}</p>
                <p className="text-sm text-gray-500">{item.company} &middot; {item.location}</p>
              </div>

              {deleteId === item.id ? (
                <div className="flex items-center gap-2 ml-4">
                  <span className="text-sm text-red-600 font-medium hidden sm:inline">Delete?</span>
                  <button
                    onClick={() => handleDelete(item.id)}
                    className="button btn-danger text-xs px-3 py-1.5"
                  >
                    Confirm
                  </button>
                  <button
                    onClick={() => setDeleteId(null)}
                    className="button btn-secondary text-xs px-3 py-1.5"
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <div className="flex items-center gap-2 ml-4">
                  <button
                    onClick={() => navigate(`/edit-internship/${item.id}`)}
                    className="button btn-secondary text-xs px-3 py-1.5"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => setDeleteId(item.id)}
                    className="p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {toast && (
        <div className="fixed bottom-6 right-6 flex items-center gap-2 bg-white border border-gray-200 shadow-lg rounded-lg px-4 py-3 animate-fade-in">
          <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-sm text-gray-700">{toast}</span>
        </div>
      )}
    </div>
  );
};

export default EditInternships;
